/* Copyright 2024 City Trax Limited. All rights reserved. */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import TextTunerForm from './TextTuner/TextTunerForm';
import TextTunerList from './TextTuner/TextTunerList';

import ErrorPage from "./ErrorPage";
import Home from './Home';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { Amplify } from 'aws-amplify';
import "@cloudscape-design/global-styles/index.css"

import TextTuner from './TextTuner/TextTuner';


import { applyTheme } from '@cloudscape-design/components/theming';

const theme = {
  tokens: {
    colorBackgroundLayoutToggleDefault: '#001829',
    colorBackgroundLayoutToggleHover: '#00254b',
    colorBackgroundButtonPrimaryDefault: '#0b54a1',
    colorBackgroundButtonPrimaryHover: '#00254b',
    // colorBackgroundButtonNormalDefault: '#0b54a1',
    // colorBackgroundButtonNormalHover: '#00254b',
    colorTextButtonNormalDefault: '#0b54a1',
    colorBorderButtonNormalDefault: '#0b54a1',
    colorBorderButtonNormalHover: '#00254b',
    colorTextAccent: '#0b54a1',
    colorBorderItemSelected: '#0b54a1',

  },
  contexts: {

    'top-navigation': {
      tokens: {
        colorBackgroundContainerContent: '#001829',
      },
    },
  },
};

applyTheme({ theme });


Amplify.configure({
  Auth: {
    Cognito: {
      userPoolClientId: window.config.userPoolClientId,
      userPoolId: window.config.userPoolId,
      identityPoolId: window.config.identityPoolId
    }
  },
  API: {
    REST: {
      'textTuner': {
        endpoint:
          window.config.textTunerApiEndpoint,
      },
    }
  },
});
console.log(Amplify.getConfig())


let cityTraxRoutes = [];

if (window.config.textTunerApiEndpoint !== undefined) {
  cityTraxRoutes.push({
    path: "/text-tuner/",
    element: <TextTuner />,
    children: [
      {
        path: "/text-tuner/",
        element: <TextTunerList />,
      },
      {
        path: "/text-tuner/new",
        element: <TextTunerForm />,
      },

    ]
  })
}

cityTraxRoutes.push({
  index: true,
  element: <Home />,
})

const router = createBrowserRouter([
  {
    path: "/",
    element: <App children={undefined} />,
    errorElement: <ErrorPage />,
    children: cityTraxRoutes,
  },
]);



const root = ReactDOM.createRoot(
  document.getElementById('root')
);
root.render(
  <React.StrictMode >

    <RouterProvider router={router} />
  </React.StrictMode >
);
